import React from 'react';
import { Modal } from 'rsuite';

const MatchedChildListModal = ({ show, onClose, matchedChildListData = [], onOpen }) => {
  return (
    <Modal
      backdrop={false}
      className="matched-child-list-modal"
      show={show}
      size="sm"
      onHide={onClose}
    >
      <Modal.Header>
        <Modal.Title className="text-black fw-bold fs-4 mb-0">
          Matched Child Vendors
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="no-scrollbar" style={{ overflow: 'auto', height: '300px' }}>
        <div className="d-flex flex-column gap-2">
          {console.log("matchedChildListData =>> ", matchedChildListData)}
          {matchedChildListData.map((vendor, index) => (
            <div
              key={index}
              className="card shadow-sm border-0 p-3"
              style={{
                transition: 'transform 0.3s, box-shadow 0.3s, border 0.3s, background-color 0.3s',
                cursor: 'pointer',
                maxWidth: '95%',

              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.02)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
                e.currentTarget.style.border = '2px solid #007bff';
                e.currentTarget.style.backgroundColor = '#f0f8ff';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.1)';
                e.currentTarget.style.border = '2px solid transparent';
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              <div className="card-body d-flex justify-content-between align-items-center">
                <div className="d-flex">
                  <h5 className="rs-panel-title mb-0 fs-4" style={{ display: 'flex', alignItems: 'center' }} >
                    {vendor?.suppliername || 'No Supplier Name'}
                  </h5>
                  <h5 className="btn text-white bg-green ms-3 mb-0" style={{ display: 'flex', alignItems: 'center' }} >
                    {vendor?.vendorsInCall?.status || 'N/A'}
                  </h5>
                </div>
                <button className="btn btn-primary h4 mb-0 fw-bold rounded text-white" onClick={() => onOpen(vendor)}>Open</button>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn width-100 h4 mb-0 fw-bold rounded text-white btn-secondary" onClick={onClose}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MatchedChildListModal;
